export default __webpack_public_path__ + "static/thehub-md@2x-ae9a8d765caf831ca7ef5a20b3e99b55.png";